type WorkflowStepDescriptionProps = {
  description?: string | null;
  className?: string;
};

/**
 * Renders workflow step description with multi-line support (preserves newlines).
 * Renders nothing when description is missing or empty.
 */
export const WorkflowStepDescription = ({
  description,
  className = 'txt-small-regular text-text-secondary mt-1',
}: WorkflowStepDescriptionProps) => {
  if (!description?.trim()) return null;
  return (
    <p className={`whitespace-pre-line ${className}`.trim()}>{description}</p>
  );
};
